module.exports = __webpack_public_path__ + "img/docx.6f8583a4.svg";